import Vue from 'vue';
import slugify from 'slugify';

Vue.filter('slugify', (text, replacement = '_') => {
  const options = {
    replacement,
    lower: true,
  }
  return slugify(text, options);
})

export default slugify;
